export default function ClearTickersModal({ clearTickers, closeModal }) {
	return (
		<>
			<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
				<div className="bg-white p-8 rounded-lg w-96">
					<h2 className="text-2xl font-bold mb-4">Clear Tickers</h2>
					<p className="mb-4">
						Are you sure you want to clear all tickers?
					</p>
					<div className="flex justify-end gap-2">
						<button
							className="border rounded-lg px-4 py-2 font-medium hover:bg-black/10 active:scale-95 transition-all"
							onClick={closeModal}
						>
							Cancel
						</button>
						<button
							className="border rounded-lg px-4 py-2 text-white font-medium bg-red-400 hover:bg-red-500 active:scale-95 transition-all"
							onClick={clearTickers}
						>
							Clear
						</button>
					</div>
				</div>
			</div>
		</>
	);
}
